import React, {useState} from 'react';

import {StarIcon} from './svg';
import {cx} from '../util';

const Star = ({filled, starClassName}) => (
  <StarIcon className={cx('h-6 w-6', filled ? 'text-yellow-400' : 'text-gray-300', starClassName)} />
);

const StarRating = ({
  onRating = () => {},
  initialRating = 0,
  count = 5,
  displayOnly = false,
  tooltipArray,
  starClassName,
}) => {
  const [selectedRating, setSelectedRating] = useState(null);
  const [hoverRating, setHoverRating] = useState(null);

  const currentRating = hoverRating ?? selectedRating ?? initialRating;
  const displayRating = Math.round(currentRating);

  const hasTooltips = tooltipArray?.length === count;
  const tooltipText = (hasTooltips && displayRating > 0)
    ? tooltipArray[displayRating - 1]
    : null;

  const stars = (
    <span
      className="inline-flex items-center"
      onMouseLeave={displayOnly ? undefined : () => setHoverRating(null)}
      role={displayOnly ? 'img' : 'radiogroup'}
      aria-label={displayOnly ? `${displayRating} out of ${count} stars` : `Rate out of ${count} stars`}
    >
      {Array.from({length: count}, (unused, index) => (displayOnly ? (
        <Star key={index} filled={index < displayRating} starClassName={starClassName} />
      ) : (
        <button
          key={index}
          type="button"
          role="radio"
          aria-checked={(selectedRating ?? initialRating) === index + 1}
          aria-label={tooltipArray?.[index] || `${index + 1} out of ${count} stars`}
          onClick={() => {
            setSelectedRating(index + 1);
            onRating(index + 1);
          }}
          onMouseEnter={() => setHoverRating(index + 1)}
          onFocus={() => setHoverRating(index + 1)}
          onBlur={() => setHoverRating(null)}
          className="cursor-pointer"
        >
          <Star filled={index < displayRating} starClassName={starClassName} />
        </button>
      )))}
    </span>
  );

  if (!hasTooltips) return stars;

  return (
    <div className="flex items-center">
      {stars}
      <span className="flex-1 min-w-0 ml-3 truncate text-indigo font-medium text-md">
        {tooltipText}
      </span>
    </div>
  );
};

export default StarRating;
